const SectionData = [
    { value: 'B1', label: 'B1', color: '#00B8D9', isFixed: true },
    { value: 'B2', label: 'B2', color: '#0052CC', isFixed: true },
    { value: 'B3', label: 'B3', color: '#5243AA' },
    { value: 'B4', label: 'B4', color: '#FFC400' },
    { value: 'B5', label: 'B5', color: '#36B37E' },
    { value: 'B6', label: 'B6', color: '#00875A' },
    { value: 'B7', label: 'B7', color: '#253858' },
    { value: 'B8', label: 'B8', color: '#666666' },
    { value: 'B9', label: 'B9', color: '#FF5630', isFixed: true },
    { value: 'B10', label: 'B10', color: '#FF8B00' },
];
export default SectionData;